import Syinnerhtml from "./sy-innerhtml";

export default Syinnerhtml